import React, { useEffect, useState } from 'react';

const AboutUsSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section style={styles.section}>
      <h2 style={styles.heading}>About Us</h2>
      <div style={styles.wrapper}>
        <div style={{ ...styles.contentBox, flexDirection: isMobile ? 'column' : 'row' }}>
          <div style={{ ...styles.textContainer }}>
            <h3 style={styles.subheading}>Dr. Homi Bhabha State University, Mumbai (HBSU)</h3>
            <p style={styles.paragraph}>
              The Government of Maharashtra has established the Dr. Homi Bhabha State University, as a Cluster University in 2019,
              with the Institute of Science, Mumbai; Elphinstone College, Mumbai; Sydenham College, Mumbai; Secondary Training College, Mumbai;
              Institute of Forensic Science, Mumbai; and Sydenham Institute of Management Studies, Research and Entrepreneurship Education, Mumbai as the Constituent Colleges.
            </p>
            <p style={styles.paragraph}>
              The Institute of Science, Mumbai is the <strong>Lead Institute</strong> of the University.
              All the colleges are more than 100 years old; the youngest the Institute of Science was established in 1920;
              while the oldest the Elphinstone College was established in 1835.
            </p>
            <p style={styles.paragraph}>
              The University is an independent degree granting entity with its own Rules and Regulations. This is the first University of its kind
              in the State of Maharashtra and is established as per the guidelines of Rashtriya Ucchatar Shiksha Abhiyan (RUSA).
            </p>
            <p style={styles.paragraph}>
              The establishment of this University is expected to charge the Higher Education system in the State with new vigour.
              It will lead to optimum use of resources of the constituent colleges and will offer the learners wide options of learning
              with flexibility and assist them with student-friendly support system.
            </p>
            <p style={styles.paragraph}>
              It will generate contemporary and relevant infrastructure and provide undergraduate and postgraduate programmes in diverse disciplines
              under choice based credit system (CBCS). The CBCS will adopt a cafeteria approach, where the students will be given freedom to select
              some courses from an array of courses as per their preferences. The students may take some of the courses across the constituent colleges.
            </p>
            <p style={styles.paragraph}>
              The programmes will be dynamic and demand driven. The students may participate in various activities organized by the constituent colleges.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '50px 20px',
    backgroundColor: '#fff',
    fontFamily: 'Arial, sans-serif'
  },
  heading: {
    textAlign: 'center',
    color: '#FFA500',
    fontSize: '30px',
    marginBottom: '40px',
    borderBottom: '3px solid #FFA500',
    display: 'inline-block',
    paddingBottom: '5px'
  },
  wrapper: {
    maxWidth: '1100px',
    margin: '0 auto',
    backgroundColor: '#FFF8E1',
    borderRadius: '12px',
    boxShadow: '0 4px 25px rgba(0,0,0,0.1)',
    overflow: 'hidden'
  },
  contentBox: {
    display: 'flex',
    padding: '30px',
    flexWrap: 'wrap'
  },
  textContainer: {
    flex: 1,
    padding: '10px'
  },
  subheading: {
    fontSize: '22px',
    color: '#333',
    marginBottom: '20px',
    fontWeight: 'bold'
  },
  paragraph: {
    color: '#333',
    fontSize: '15px',
    marginBottom: '15px',
    lineHeight: '1.7'
  }
};

export default AboutUsSection;
